import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const MergeFieldsSection = ({ clientA, clientB, selectedFields, onFieldSelect }) => {
  const { t: tr } = useTranslation();
  const fields = [
    { key: 'firstName', label: tr("common:firstName") },
    { key: 'lastName', label: tr("common:lastName") },
    { key: 'mobile', label: tr("common:phone") },
    { key: 'email', label: tr("common:email") },
    { key: 'address', label: tr("manage:address_124") },
    { key: 'invoiceData', label: tr("manage:invoiceDetails_126") },
    { key: 'notes', label: tr("manage:notes_10") },
  ];

  return (
    <div className="merge-fields-section mb-4">
      <h5>{tr("manage:clientDetails_253")}</h5>
      <table className="table table-sm">
        <thead>
          <tr>
            <th style={{ width: '20%' }}>{tr("manage:field_254")}</th>
            <th style={{ width: '40%' }}>{tr("manage:clientAPrimary_138")}</th>
            <th style={{ width: '40%' }}>{tr("manage:clientBToBeRemoved_140")}</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((field) => {
            const valueA = clientA[field.key] || '(brak)';
            const valueB = clientB[field.key] || '(brak)';
            const selected = selectedFields[field.key] || 'A';
            const valuesDiffer = valueA !== valueB;

            return (
              <tr key={field.key}>
                <td><strong>{field.label}</strong></td>
                <td>
                  {valuesDiffer ? (
                    <>
                      <input
                        type="radio"
                        className="form-check-input me-2"
                        name={field.key}
                        id={`${field.key}-A`}
                        checked={selected === 'A'}
                        onChange={() => onFieldSelect(field.key, 'A')}
                      />
                      <label htmlFor={`${field.key}-A`} className={selected === 'A' ? 'fw-bold text-primary' : ''}>
                        {valueA}
                      </label>
                    </>
                  ) : (
                    <span className="text-muted">{valueA}</span>
                  )}
                </td>
                <td>
                  {valuesDiffer ? (
                    <>
                      <input
                        type="radio"
                        className="form-check-input me-2"
                        name={field.key}
                        id={`${field.key}-B`}
                        checked={selected === 'B'}
                        onChange={() => onFieldSelect(field.key, 'B')}
                      />
                      <label htmlFor={`${field.key}-B`} className={selected === 'B' ? 'fw-bold text-primary' : ''}>
                        {valueB}
                      </label>
                    </>
                  ) : (
                    <span className="text-muted">{valueB}</span>
                  )}
                </td>
              </tr>
            );
          })}
          <tr>
            <td><strong>{tr("manage:agreement_255")}</strong></td>
            <td>
              {clientA.hasContract ? tr("manage:extraSigned_65") : tr("manage:extraMissing_66")}
            </td>
            <td className="text-muted">
              {clientB.hasContract ? tr("manage:extraSigned_65") : tr("manage:extraMissing_66")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

MergeFieldsSection.propTypes = {
  clientA: PropTypes.object.isRequired,
  clientB: PropTypes.object.isRequired,
  selectedFields: PropTypes.object.isRequired,
  onFieldSelect: PropTypes.func.isRequired,
};

export default MergeFieldsSection;
